import { trackEvent } from 'segment_analytics/events'

const defaultEventProps = {
  platform: 'web',
}

const statsDrillInTapped = ({
  ...props
}: {
  subscriber: boolean
  chart: string
}) => {
  const properties = {
    ...defaultEventProps,
    ...props,
  }
  return trackEvent('stats_drill_in_tapped', properties)
}

const statsDrillInCarouselScrolled = () => {
  return trackEvent('stats_drill_in_carousel_scrolled', defaultEventProps)
}

const statsDrillInFinishedListTapped = ({
  ...props
}: {
  subscriber: boolean
  chart: string
}) => {
  const properties = {
    ...defaultEventProps,
    ...props,
  }
  return trackEvent('stats_drill_in_finished_list_tapped', properties)
}

const statsDrillInStreaksLogTapped = () => {
  return trackEvent('stats_drill_in_streaks_log_tapped', defaultEventProps)
}

const statsDrillInUpsellLearnMoreTapped = () => {
  return trackEvent(
    'stats_drill_in_upsell_learn_more_tapped',
    defaultEventProps
  )
}

export const statsDrill = {
  statsDrillInTapped,
  statsDrillInCarouselScrolled,
  statsDrillInFinishedListTapped,
  statsDrillInStreaksLogTapped,
  statsDrillInUpsellLearnMoreTapped,
}
